<template>
    <div class="ad-page">
        <page-header :title="title" :items="items" />

        <div v-if="footerColumn.id" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <edit-form
                            v-model="footerColumn"
                            :validation="$v"
                            :server-errors="serverErrors"
                        />
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-3">
                            <button
                                class="
                                    btn btn-success btn-static
                                    waves-effect waves-light
                                    m-1
                                "
                                @click="submitHandler"
                            >
                                <i class="fas fa-save" />
                                Save
                            </button>
                        </div>

                        <item-information
                            :sections="sections"
                            :item="footerColumn"
                            :options="options"
                        />
                    </div>
                </div>
            </div>
        </div>
        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';
import ItemInformation from '@/components/elements/ItemInformation';

import EditForm from '@/components/footer-columns/EditForm';

export default {
    page: {
        title: 'Manage footer column'
    },

    validations: {
        footerColumn: {
            title: {
                required
            },
            order: {
                required
            }
        }
    },

    components: {
        EditForm,
        ItemInformation
    },

    data() {
        const { id = null } = this.$route.params;

        return {
            title: 'Edit footer column',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Footer columns',
                    to: '/footer-columns'
                },
                {
                    text: 'Edit',
                    active: true
                }
            ],
            id,
            footerColumn: {},
            serverErrors: [],
            options: {
                deleteButton: false
            }
        };
    },

    computed: {
        sections() {
            return {
                status: true
            };
        }
    },

    async created() {
        try {
            this.footerColumn = await this.getFooterColumn(this.id);
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }

        return;
    },

    methods: {
        ...mapActions({
            getFooterColumn: 'footerColumns/show',
            updateFooterColumn: 'footerColumns/update'
        }),

        async submitHandler() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                const { updatedAt } = await this.updateFooterColumn({
                    id: this.id,
                    data: this.footerColumn
                });

                this.footerColumn.updatedAt = updatedAt;

                this.$toaster('Footer column updated!');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data?.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
